import api from "../../Interceptor"
import { fetchCurrenciesFailure, fetchCurrenciesStart, fetchCurrenciesSuccess } from "./currencySlice";

export const fetchAllCurrencies = async (dispatch) => {
    dispatch(fetchCurrenciesStart())
    try {
        const { data } = await api.get(`${process.env.REACT_APP_API_BASE_URL}/api/v1/getAllCurrencies`);
        dispatch(fetchCurrenciesSuccess(data))
    } catch (error) {
        dispatch(fetchCurrenciesFailure(error?.response?.data?.message || "Failed To Fetch Currencies"))
    }
}